import { Component, OnInit, ViewChild, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { catchError, combineLatest, Observable, tap } from 'rxjs';
import { AccessTypeSelection } from '../../../../common/enums/access-type-selection.enum';
import {
    selectGranteeAccessType,
    selectGranteeClientType,
} from '../../../store/selectors/grantee.selector';
import { StepperComponent } from '../../stepper/stepper.component';
import { PageComponent } from '../page.component';
import { FlowKey } from '../../../enums/flow-keys.enum';
import { ClientTypes } from '../../../../common/enums/client-types.enum';
import { ErrorPage } from '../../../services/generic-error/error-page-utils';
import { ErrorService } from '../../../services/generic-error/error.service';
import { NgClass } from '@angular/common';

@Component({
    selector: 'zci-grantee-landing-page',
    templateUrl: './grantee-landing-page.component.html',
    styleUrls: ['./grantee-landing-page.component.scss'],
    imports: [
        NgClass,
        StepperComponent,
    ],
})
export class GranteeLandingPageComponent extends PageComponent implements OnInit {
    private readonly route = inject(ActivatedRoute);
    private readonly store = inject(Store);
    private readonly errorService = inject(ErrorService);

    // TODO If there is an error, redirect to error page

    accessLevel$: Observable<AccessTypeSelection> = this.store.select(selectGranteeAccessType);
    granteeClientType$: Observable<ClientTypes> = this.store.select(selectGranteeClientType);

    flowKey: FlowKey;

    @ViewChild(StepperComponent)
    stepper: StepperComponent;

    ngOnInit(): void {
        combineLatest([this.route.data, this.granteeClientType$])
            .pipe(
                tap(([routeData, clientType]) => {
                    const { accessLevel, isExistingClient } = routeData.validateToken;

                    if (!accessLevel) {
                        throw new Error(
                            'AccessLevel is missing after routing to GranteeLandingPageComponent',
                        );
                    }
                    // TODO FIX THIS AGAIN
                    /* istanbul ignore next */
                    this.flowKey = this.getFlowKey(clientType, accessLevel, isExistingClient);
                }),
                catchError((err) => {
                    this.errorService.showError(ErrorPage.TECH_DIFF);
                    return err;
                }),
            )
            .subscribe();
    }

    private getFlowKey(
        clientType: ClientTypes,
        accessLevel: AccessTypeSelection,
        isExistingClient: boolean,
    ): FlowKey {
        if (isExistingClient) {
            return FlowKey.EXISTING_GRANTEE_LIMITED;
        }

        const isNonVanguardClient = clientType === ClientTypes.NON_VGCLIENT;
        const isLimitedAccess = accessLevel === AccessTypeSelection.LIMITED_ACCESS;

        if (!isNonVanguardClient) {
            return isLimitedAccess ? FlowKey.NEW_GRANTEE_LIMITED : FlowKey.NEW_GRANTEE_INFO_ONLY;
        }
        return isLimitedAccess
            ? FlowKey.NON_VG_CLIENT_LIMITED
            : FlowKey.NON_VG_CLIENT_INFO_ONLY;

    }
}
